import { useRef, useEffect } from 'react';
import { ff } from '@atlassian/jira-feature-flagging';
import type { DiffValue } from './types';

export const useDiffCheck = (nextValues: DiffValue[] = []) => {
	const ref = useRef<DiffValue[]>([]);
	const prevValues = ref.current;

	const isFFEnabled = ff('com.atlassian.rm.jpo.jpo3cloud.the-sync-field-in-the-strict-mode-_8c083');

	useEffect(() => {
		if (isFFEnabled) {
			ref.current = nextValues;
		}
	}, [isFFEnabled, nextValues]);

	if (!isFFEnabled) {
		ref.current = nextValues;
	}

	return prevValues.length
		? prevValues.some((value: DiffValue, i: number) => nextValues[i] !== value)
		: false;
};
